export default __webpack_public_path__ + "static/media/Component 71 – 2.e41f4630.svg";